import type { EntryStatus } from '@/api/client'
import { cn } from '@/lib/cn'
import { useTranslation } from 'react-i18next'

interface Props {
  status: EntryStatus
  className?: string
}

// EntryStatusBadge renders the journal entry status using monochrome
// zinc accents (draft=muted, validated=strong, cancelled=strikethrough).
export function EntryStatusBadge({ status, className }: Props) {
  const { t } = useTranslation('accounting')
  const styles: Record<EntryStatus, string> = {
    draft: 'bg-muted text-muted-foreground',
    validated: 'bg-primary text-primary-foreground',
    cancelled: 'bg-muted text-muted-foreground line-through',
  }
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        styles[status],
        className,
      )}
    >
      {t(`status.${status}`)}
    </span>
  )
}
